var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramOwner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 23.25C20.75 21.2609 19.9598 19.3532 18.5533 17.9467C17.1468 16.5402 15.2391 15.75 13.25 15.75M13.25 15.75C11.2609 15.75 9.35322 16.5402 7.9467 17.9467C6.54018 19.3532 5.75 21.2609 5.75 23.25M13.25 15.75C16.0114 15.75 18.25 13.5114 18.25 10.75C18.25 7.98858 16.0114 5.75 13.25 5.75C10.4886 5.75 8.25 7.98858 8.25 10.75C8.25 13.5114 10.4886 15.75 13.25 15.75ZM25.75 13.25C25.75 20.1536 20.1536 25.75 13.25 25.75C6.34644 25.75 0.75 20.1536 0.75 13.25C0.75 6.34644 6.34644 0.75 13.25 0.75C20.1536 0.75 25.75 6.34644 25.75 13.25Z",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramOwner);
export default __webpack_public_path__ + "static/media/ProgramOwner.29eccd1a8eb6b6f24ed6ac334ba4237f.svg";
export { ForwardRef as ReactComponent };